export enum ApiRouteKeys {
  partners = 'partners',
  companies = 'companies',
  accountingPeriods = 'accounting_periods',
  vatFrameworks = 'vat_frameworks',
  pcgEntries = 'pcg_entries',
  caFrameworks = 'ca_frameworks',
  loans = 'loans',
  immobilisations = 'immobilisations',
  leaseContracts = 'lease_contracts',
  suppliers = 'suppliers',
  supplierlines = 'supplier_lines',
  pieces = 'pieces',
  invoices = 'invoices',
  accountInterest = 'account_interests',
  documents = 'documents',
  bankTransactions = 'bank_transactions',
  imputations = 'imputations',
  users = 'users',
  revisionAssistants = 'revision_assistants'
}

export const API_ROUTE_REPLACE_COMPANY_KEY = '{companyId}';
export const API_ROUTE_REPLACE_PARTNER_KEY = '{partnerId}';
export const API_ROUTE_REPLACE_BUSINESS_UNIT_KEY = '{businessUnitId}';
export const API_ROUTE_REPLACE_ACCOUNTING_PERIOD_KEY = '{accountingPeriodId}';
export const API_ROUTE_REPLACE_USER_KEY = '{userId}';
export const API_ROUTE_BASE = 'api/v1/expert';
export const LEGAL_API_ROUTE_BASE = 'api/v1/legal';
export const COMPANY_API_ROUTE_BASE =
  `${API_ROUTE_BASE}/${ApiRouteKeys.companies}/${API_ROUTE_REPLACE_COMPANY_KEY}` as const;
export const PARTNER_API_ROUTE_BASE =
  `${API_ROUTE_BASE}/${ApiRouteKeys.partners}/${API_ROUTE_REPLACE_PARTNER_KEY}` as const;
export const LEGAL_COMPANY_API_ROUTE_BASE =
  `${LEGAL_API_ROUTE_BASE}/${ApiRouteKeys.companies}/${API_ROUTE_REPLACE_COMPANY_KEY}` as const;
export const ACCOUNTING_PERIOD_API_ROUTE_BASE =
  `${COMPANY_API_ROUTE_BASE}/${ApiRouteKeys.accountingPeriods}/${API_ROUTE_REPLACE_ACCOUNTING_PERIOD_KEY}` as const;
export const DOCUMENT_REQUEST_API_ROUTE_BASE = `${COMPANY_API_ROUTE_BASE}/document_requests` as const;

export const API_ROUTES = {
  companyAccountingPeriodVatFramework: (accountingPeriodId: number): string =>
    `${COMPANY_API_ROUTE_BASE}/${ApiRouteKeys.accountingPeriods}/${accountingPeriodId}/${ApiRouteKeys.vatFrameworks}`,
  companyAccountingPeriodCaFramework: (accountingPeriodId: number): string =>
    `${COMPANY_API_ROUTE_BASE}/${ApiRouteKeys.accountingPeriods}/${accountingPeriodId}/${ApiRouteKeys.caFrameworks}`
};

export const API_HEADERS = {
  workbookSheetAntiMoneyLaunderingV2: 'application/vnd.tiime.expert.anti_money_laundering.v2+json',
  partnerUsersV2: 'application/vnd.tiime.expert.partners.users.v2+json',
  contributorJobsV2: 'application/vnd.tiime.contributor-jobs.v2+json',
  accountingPeriodCloseV4: 'application/vnd.tiime.accounting_period_close.v4+json',
  documentTransactionsMatchingsV2: 'application/vnd.tiime.document_transactions_matchings.v2+json',
  accountingConfigAsyncV2: 'application/vnd.tiime.accounting_config_async.v2+json',
  projectionsV2: 'application/vnd.tiime.expert.projection.v2+json',
  fiscalResultV2: 'application/vnd.tiime.fiscal_result.v2+json',
  fiscalResultV3: 'application/vnd.tiime.fiscal_result.v3+json',
  consistencyCheckV3: 'application/vnd.tiime.consistency_checks.v3+json',
  exportV3: 'application/vnd.tiime.export.v3+json',
  balancesV2: 'application/vnd.tiime.balances.v2+json',
  piecesV2: 'application/vnd.tiime.pieces.v2+json',
  bankTransactionsV2: 'application/vnd.tiime.bank_transactions.v2+json',
  imputationsV2: 'application/vnd.tiime.imputations.v2+json',
  missionAcceptanceFilesV2: 'application/vnd.tiime.expert.mission_acceptance_file.type.v2+json',
  vatFrameworkV2: 'application/vnd.tiime.vat_framework.v2+json',
  vatDeclarationsV2: 'application/vnd.tiime.vat_declarations.v2+json',
  tasksV2: 'application/vnd.tiime.tasks.v2+json',
  attestationsV2: 'application/vnd.tiime.attestations.v2+json',
  invoiceNotReceivedAccountParametersV2: 'application/vnd.tiime.invoice_not_received_account_parameters.v2+json',
  invoiceToEstablishAccountParametersV2: 'application/vnd.tiime.invoice_to_establish_account_parameters.v2+json',
  documentRequestTemplateV2: 'application/vnd.tiime.document_request_template_v2+json'
};

export const LEGAL_API_HEADERS = {
  documentLegalV2: 'application/vnd.tiime.apps_document_legal.v2+json'
};

export const API_ROUTE_EXPAND = {
  pdpConfig: 'pdp_config'
};
